import type { HighlightBlock } from '../types/query'

/**
 * Build an OpenSearch highlight block.
 *
 * The result card renders `<mark>` substitutions for matched terms.
 * @param fields Highlight target fields, typically `['event.*', 'normalized_fields.*']`.
 */
export function buildHighlight(fields: ReadonlyArray<string>): HighlightBlock {
	const fieldsBlock: HighlightBlock['fields'] = {}
	for (const field of fields) {
		fieldsBlock[field] = {}
	}

	return {
		pre_tags: ['<mark>'],
		post_tags: ['</mark>'],
		fields: fieldsBlock,
	}
}
